// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__irHR5","sendOtp":"AuthorizeToLogin_sendOtp__j0sBq"};